var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMessagesBlue = function SvgIconMessagesBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-messages",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "area",
    fill: "#6a6a6a",
    opacity: 0.002,
    d: "M0 0h36v36H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-message",
    transform: "translate(-639.955 -427.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M631.264 288.473a.988.988 0 0 1-.472-.119 1 1 0 0 1-.528-.881v-3.341a9.5 9.5 0 0 1 2.5-18.66h5a9.5 9.5 0 0 1 0 19h-.2l-5.748 3.832a1 1 0 0 1-.552.169Zm1.5-21a7.5 7.5 0 0 0-1.325 14.876 1 1 0 0 1 .825.984v2.267l4.445-2.963a1 1 0 0 1 .555-.168h.5a7.5 7.5 0 0 0 0-15Z",
    transform: "translate(22.691 169.043)",
    fill: "#1eaae1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M630.264 276.478a1 1 0 0 1-1-1v-.01a1 1 0 1 1 1 1.006Z",
    transform: "translate(22.691 169.043)",
    fill: "#bee6fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M635.264 276.478a1 1 0 0 1-1-1v-.01a1 1 0 1 1 1 1.006Z",
    transform: "translate(22.691 169.043)",
    fill: "#bee6fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M640.264 276.478a1 1 0 0 1-1-1v-.01a1 1 0 1 1 1 1.006Z",
    transform: "translate(22.691 169.043)",
    fill: "#bee6fa"
  }))));
};
export { SvgIconMessagesBlue as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1tZXNzYWdlcyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiI+CiAgPHJlY3QgaWQ9ImFyZWEiIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgZmlsbD0iIzZhNmE2YSIgb3BhY2l0eT0iMC4wMDIiLz4KICA8ZyBpZD0iY2hhdC1tZXNzYWdlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjM5Ljk1NSAtNDI3LjEzMSkiPgogICAgPHBhdGggaWQ9IlBhdGhfMTQ3IiBkYXRhLW5hbWU9IlBhdGggMTQ3IiBkPSJNNjMxLjI2NCwyODguNDczYS45ODguOTg4LDAsMCwxLS40NzItLjExOSwxLDEsMCwwLDEtLjUyOC0uODgxdi0zLjM0MWE5LjUsOS41LDAsMCwxLDIuNS0xOC42Nmg1YTkuNSw5LjUsMCwwLDEsMCwxOWgtLjJsLTUuNzQ4LDMuODMyQTEsMSwwLDAsMSw2MzEuMjY0LDI4OC40NzNabTEuNS0yMWE3LjUsNy41LDAsMCwwLTEuMzI1LDE0Ljg3NiwxLDEsMCwwLDEsLjgyNS45ODRWMjg1LjZsNC40NDUtMi45NjNhMSwxLDAsMCwxLC41NTUtLjE2OGguNWE3LjUsNy41LDAsMCwwLDAtMTVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMi42OTEgMTY5LjA0MykiIGZpbGw9IiMxZWFhZTEiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzE0OCIgZGF0YS1uYW1lPSJQYXRoIDE0OCIgZD0iTTYzMC4yNjQsMjc2LjQ3OGExLDEsMCwwLDEtMS0xdi0uMDFhMSwxLDAsMSwxLDEsMS4wMDZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMi42OTEgMTY5LjA0MykiIGZpbGw9IiNiZWU2ZmEiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzE0OSIgZGF0YS1uYW1lPSJQYXRoIDE0OSIgZD0iTTYzNS4yNjQsMjc2LjQ3OGExLDEsMCwwLDEtMS0xdi0uMDFhMSwxLDAsMSwxLDEsMS4wMDZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMi42OTEgMTY5LjA0MykiIGZpbGw9IiNiZWU2ZmEiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzE1MCIgZGF0YS1uYW1lPSJQYXRoIDE1MCIgZD0iTTY0MC4yNjQsMjc2LjQ3OGExLDEsMCwwLDEtMS0xdi0uMDFhMSwxLDAsMSwxLDEsMS4wMDZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMi42OTEgMTY5LjA0MykiIGZpbGw9IiNiZWU2ZmEiLz4KICA8L2c+Cjwvc3ZnPgo=";